import React                      from 'react'
import { Col
       , Input
       , Row }                    from 'antd'
import { observable }             from 'mobx'
import { Observer }               from 'mobx-react'

import { TEXT
       , tr }                     from '../00_assets'
import { CTE }                    from '../01_core'


export enum FIELD_TYPE
{
  INPUT    = 'text'
, PASSWORD = 'password'
, NUMBER   = 'number'
, CUSTOM   = 'custom'
}

export const VALID =
{
  non_empty_txt: ( value: string ) => value && value.trim && value.trim( ) !== ''? 0 : 1
, non_empty_num: ( value: number ) => value !== undefined && value !== 0? 0 : 1
, non_empty_enum: ( value: number ) => value !== undefined && value !== CTE.ENUM_NON_SELECTED? 0 : 1
}

export interface IFormField<T>
{
  label: TEXT
  init: T
  type: FIELD_TYPE
  is_valid: ( value: T ) => number
  required?: boolean
  args?: any
}

export interface IFieldFormModel<T> extends IFormField<T>
{
  error: ( ) => boolean
  value: ( ) => T
  check: ( ) => boolean
  bind : ( ) => { value: T
//                , error: boolean
                , onChange: ( ev: any ) => void }
} 


export interface IFormSpec
{
  [key: string]: IFormField<any>
}

export interface IFormEditorModel
{ [ key: string ]: IFieldFormModel<any> }

export interface IFormEditor
{
  model     : IFormEditorModel
  fields    : ( ) => object
  has_errors: ( ) => boolean
  show_error: ( ) => boolean
}

function input_event ( ev: React.ChangeEvent<HTMLInputElement> ) 
{
  return ev.target.value ;
}

function id_event ( ev: string | number ) 
{
  return ev ;
}


const extractor_for_field =
{
  [ FIELD_TYPE.INPUT    ]: input_event
, [ FIELD_TYPE.PASSWORD ]: input_event
, [ FIELD_TYPE.NUMBER   ]: input_event
, [ FIELD_TYPE.CUSTOM   ]: id_event
}


export function form_model ( spec: IFormSpec, fields?: ( data: IFormEditorModel ) => any ) : IFormEditor
{
  const model: IFormEditorModel = { } ;

  for ( const key in spec )
     {
        const field = spec[ key ] ;

        model[ key ] = field_form_model( field, extractor_for_field[ field.type ] ) ;
     }

  return { model
         , fields: fields? ( ) => fields( model ) : ( ) =>
           {
             const ret: any = { } ;

             for ( const key in spec ) ret[ key ] = model[ key ].value( ) ;

             return ret ;
           }
         , has_errors: ( ) => 
           {
             let ret = false ;

             for ( const key in spec )
                   if ( spec[ key ].required )
                        ret = model[ key ].check( ) || ret ;

             return ret ;
           }
         , show_error: ( ) =>
           {
             let ret = false ;

             for ( const key in spec ) ret = ret || model[ key ].error( ) ;

             return ret ;
           }
         } ;
}


export function field_form_model<T> ( field: IFormField<T>
                                    , event_extractor: ( ev: any ) => T
                                    ) : IFieldFormModel<T>
{
  const value = observable.box<T>( field.init )
      , error = observable.box<boolean>( false ) ;

  return { error: ( ) => error.get( )
         , value: ( ) => value.get( )
         , check: ( ) =>
           {
             error.set( field.is_valid( value.get( ) ) !== 0 ) ;
             return error.get( ) ;
           }
         , bind: ( ) =>
                ({ value: value.get( )
                 , error: error.get( )
                 , onChange: ( ev: React.ChangeEvent<HTMLInputElement> ) => 
                     {
                       error.set( false ) ;
                       value.set( event_extractor( ev ) ) ;
                     }
                 })
         , ...field
         } ;
}


export const FormField: React.FC< { field: IFieldFormModel<any>, args?: object } > = ({ field, children, args }) =>
{
  const all_args = Object.assign( {}, field.args || {}, args || {} )
      , render = ( ) =>
  <FormElement label={ field.label } error={ field.error( ) } required={ field.required }>
    { children || <Input type={ field.type } value={field.bind( ).value} onChange={field.bind( ).onChange} {...all_args} /> }
  </FormElement>

  return <Observer render={ render } /> ;
}

export const FormInput: React.FC<
  { label: TEXT
  , value: string
  , onChange: ( ev: React.ChangeEvent<HTMLInputElement> ) => any
  , type?: string
  , autocomplete?: string
  , disabled?: boolean
  , error?: boolean
  , required?: boolean
  } > = ( props ) =>
  <FormElement label={ props.label } error={ props.error } required={ props.required }>
      <Input
        autoComplete={ props.autocomplete }
        type={ props.type || 'text' }
        value={ props.value }
        onChange={ props.onChange }
        disabled={ props.disabled }
      />
  </FormElement>


export const FormError: React.FC< { has: boolean } > = ( { has } ) =>
<Row className="mb-1">
  <Col span={24}>
    { has? 
      <Observer render={ ( ) => <span className="text-danger">{ tr( TEXT.FORM_HAS_ERRORS ) }</span> } />
    : null
    }
  </Col>
</Row>


export const FormElement: React.FC< 
  { label: TEXT
  , required?: boolean
  , error?: boolean } > = ( { label, error, required, children } ) =>
  <Row className={ "mb-1" + (error? " has-error" : '') }>
    <Col span={10}>
      <label style={{ lineHeight: '33px' }}>
        <Observer render={ ( ) => <span>{ tr( label ) + (required? '*' : '') }</span> } />
      </label>
    </Col>
    <Col span={14}>
      { children }
    </Col>
  </Row>


export const VerFormInput: React.FC<
  { className?: string
  , label: TEXT
  , value: string
  , onChange: ( ev: React.ChangeEvent<HTMLInputElement> ) => any
  , type?: string
  } > = ( props ) =>
  <VerFormElement className={ props.className } label={ props.label }>
      <Input
        type={ props.type || 'text' }
        value={ props.value }
        onChange={ props.onChange }
      />
  </VerFormElement>


export const VerFormElement: React.FC< { className?: string, label: TEXT } > = ( props ) =>
  <Col className={ props.className }>
    <Row style={{ height: '20px', lineHeight: '20px' }}>
      <label>
        <Observer render={ ( ) => <span>{ tr( props.label ) }</span> } />
      </label>
    </Row>
    <Row>
      { props.children }
    </Row>
  </Col>
